<template>
  <div class="class-info">
    <!-- v-if="classList&& openClassList" -->
    <div class="tab_list">
      <div class="btns">
        <button class="button" :class="changeIndex == 1 ? 'blue' : 'grey'" @click="changeTab('1')">
          班级信息
        </button>
        <button class="button" :class="changeIndex == 2 ? 'blue' : 'grey'" @click="changeTab('2')">
          开放式班级
        </button>
      </div>
    </div>
    <!-- 班级信息 -->
    <div v-if="changeIndex == 1">
      <div class="center-title">
        <span>班级信息</span>
        <div class="drop-down" v-if="classSelect && classList" @mouseover="classListShow = true"
          @mouseleave="classListShow = false">
          <div class="down-title">{{ classSelect.name }}</div>
          <ul class="down-list" v-show="classListShow">
            <li class="down-info" v-for="item in classList" :key="item.id" @click="clickClass(item)">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="btns" v-if="classList.length > 0">
        <button class="button" :class="tabIndex == 1 ? 'blue' : 'grey'" @click="tableClick(1)">
          班级课程
        </button>
        <button class="button" :class="tabIndex == 2 ? 'blue' : 'grey'" @click="tableClick(2)">
          班级考试
        </button>
        <button class="button" :class="tabIndex == 3 ? 'blue' : 'grey'" @click="tableClick(3)">
          公开考试
        </button>
      </div>
      <div class="class_course" v-if="tabIndex == 1 && classList.length > 0">
        <div class="course_main">
          <div class="cont_warp">
            <ul>
              <li>
                <p class="label">课程进度</p>
                <div class="progress">
                  <div class="progress-bg">
                    <div class="progress-line" :style="{ width: classData.course_rate + '%' }"></div>
                  </div>
                  <div class="num">{{ classData.course_rate }}%</div>
                </div>
              </li>
              <li>
                <p class="label">学习有效期</p>
                <p class="text">
                  {{ classData.start_time }} 至 {{ classData.end_time }}
                </p>
              </li>
            </ul>
            <ul>
              <li>
                <p class="label">考试情况</p>
                <div class="icon_list">
                  <p class="">
                    <img src="@/assets/true.png" alt="" />
                    <span>{{ classData.exam_success }}项已通过</span>
                  </p>
                  <p class="">
                    <img src="@/assets/false.png" alt="" />
                    <span>{{ classData.exam_fail }}项已通过</span>
                  </p>
                </div>
              </li>
              <div class="flex">
                <li>
                  <p class="label">任务完成进度</p>
                  <p class="text">
                    {{ classData.finish_task }}/{{ classData.task_total }} 任务
                  </p>
                </li>
                <li class="down_cert" v-if="classData.cert_url && siteInfo.is_open_class_cert == 1">
                  <p class="label">证书下载</p>
                  <p class="text">
                    <a :href="classData.cert_url">证书下载</a>
                  </p>
                </li>
              </div>
            </ul>
          </div>
        </div>
        <ul class="class-list">
          <li class="class-list-info" v-for="item in classCourse" :key="item.id">
            <router-link :to="'/recordedInfo/' + item.id">
              <img class="info-img" :src="item.image" alt="" />
              <div class="info-content">
                <div class="info-title vertical-ellipsis">{{ item.name }}</div>
                <div class="progress">
                  <div class="num">{{ item.rate }}</div>
                  <div class="progress-bg">
                    <div class="progress-line" :style="{ width: item.rate }"></div>
                  </div>
                </div>
              </div>
            </router-link>
          </li>
          <li class="no-data" v-if="classCourse.length == 0">
            班级内还没有课程
          </li>
        </ul>
      </div>
      <ul class="test-list" v-if="classSelect && classSelect.id == '302'">
        <li class="test-info">
          <div class="test-title vertical-ellipsis">培训心得</div>
          <div class="btns">
            <router-link :to="'/textarea'" class="button blue">去考试</router-link>
          </div>
        </li>
      </ul>

      <ul class="test-list" v-if="tabIndex == 2 && classList">
        <li class="test-info" v-for="item in classExam" :key="item.id">
          <div class="exam-card-head">
            <span class="exam-badge">考试</span>
            <h3 class="test-title vertical-ellipsis">{{ item.exam_name }}</h3>
          </div>
          <div class="test-date">
            <div class="test-date-text">
              <span>{{ item.start_time }}</span>
              <span class="date-to">至 {{ item.end_time }}</span>
            </div>
          </div>
          <div class="exam-actions">
            <router-link :to="'/text/' + item.id + '/' + '1'" class="exam-btn exam-btn-primary">去考试</router-link>
            <div class="exam-actions-sub">
              <button
                class="exam-btn exam-btn-secondary"
                :disabled="isBtnLocked('score', item.id)"
                @click="viewScoreBtn(item.id, item.exam_name)"
              >查看分数</button>
              <button
                class="exam-btn exam-btn-secondary"
                :disabled="isBtnLocked('record', item.id)"
                @click="viewExamRecordBtn(item.id, item.exam_name)"
              >查看试卷</button>
            </div>
          </div>
          <div class="residue">
            <span class="residue-label">剩余次数</span>
            <span class="num">{{ item.times - item.count }}</span><span class="residue-unit">次</span>
          </div>
        </li>
        <li class="no-data" v-if="classExam.length == 0 && (classSelect && classSelect.id != '302')">班级内还没有考试</li>
      </ul>
      <ul class="test-list" v-if="tabIndex == 3 && classList">
        <li class="test-info" v-for="item in classExam" :key="item.id">
          <div class="exam-card-head">
            <span class="exam-badge">考试</span>
            <h3 class="test-title vertical-ellipsis">{{ item.exam_name }}</h3>
          </div>
          <div class="test-date">
            <div class="test-date-text">
              <span>{{ item.start_time }}</span>
              <span class="date-to">至 {{ item.end_time }}</span>
            </div>
          </div>
          <div class="exam-actions">
            <router-link :to="'/text/' + item.id + '/' + '1'" class="exam-btn exam-btn-primary">去考试</router-link>
            <div class="exam-actions-sub">
              <button
                class="exam-btn exam-btn-secondary"
                :disabled="isBtnLocked('score', item.id)"
                @click="viewScoreBtn(item.id, item.exam_name)"
              >查看分数</button>
              <button
                class="exam-btn exam-btn-secondary"
                :disabled="isBtnLocked('record', item.id)"
                @click="viewExamRecordBtn(item.id, item.exam_name)"
              >查看试卷</button>
            </div>
          </div>
          <div class="residue">
            <span class="residue-label">剩余次数</span>
            <span class="num">{{ item.times - item.count }}</span><span class="residue-unit">次</span>
          </div>
        </li>
        <li class="no-data" v-if="classExam.length == 0 && (classSelect && classSelect.id != '302')">班级内还没有考试</li>
      </ul>
      <div class="view-score" v-if="viewScore && classList">
        <div class="score-content">
          <div class="close" @click="viewScore = false"></div>
          <div class="score-title">{{ viewScoreTitle }}</div>
          <ul class="my-table">
            <li class="table-th">
              <span class="table-td" style="width: 150px">id</span>
              <span class="table-td" style="width: 200px">考试时间</span>
              <span class="table-td" style="width: 180px">分数</span>
            </li>
            <li class="table-tr" v-for="(item) in queryScore.list" :key="item.created_at">
              <span class="table-td" style="width: 150px">{{ item.id }}</span>
              <span class="table-td" style="width: 200px">{{item.created_at}}</span>
              <span class="table-td" style="width: 180px">{{queryScore.is_show_score==1 ? item.score : '--'}}</span>
              <p class="btn" v-if="queryScore.is_show_score==1" @click="examDetail(item)">查看</p>
            </li>
            <li class="table-tr nodata" v-if="queryScore.list.length == 0">
              <span class="table-td">暂无分数</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 查看试卷记录 -->
      <div class="view-score" v-if="viewExamRecord && classList">
        <div class="score-content exam-record-content">
          <div class="close" @click="viewExamRecord = false"></div>
          <div class="score-title">{{ examRecordTitle }}</div>
          <ul class="my-table">
            <li class="table-th">
              <span class="table-td" style="width: 80px">ID</span>
              <span class="table-td" style="width: 200px">考试时间</span>
              <span class="table-td" style="width: 100px">分数</span>
              <span class="table-td" style="width: 80px">操作</span>
            </li>
            <li class="table-tr" v-for="item in examRecordList" :key="item.id">
              <span class="table-td" style="width: 80px">{{ item.id }}</span>
              <span class="table-td" style="width: 200px">{{ item.created_at }}</span>
              <span class="table-td" style="width: 100px">{{ examRecordData.is_show_score == 1 ? item.score : '--' }}</span>
              <span class="table-td" style="width: 80px">
                <p class="btn" @click="examRecordDetail(item)">查看</p>
              </span>
            </li>
            <li class="table-tr nodata" v-if="examRecordList.length == 0">
              <span class="table-td">暂无考试记录</span>
            </li>
          </ul>
          <div class="exam-record-pagination" v-if="examRecordData.list && examRecordData.list.last_page > 1">
            <button class="button grey" :disabled="examRecordPage <= 1" @click="examRecordPageChange(examRecordPage - 1)">上一页</button>
            <span class="page-info">{{ examRecordPage }} / {{ examRecordData.list.last_page }}</span>
            <button class="button grey" :disabled="examRecordPage >= examRecordData.list.last_page" @click="examRecordPageChange(examRecordPage + 1)">下一页</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 开放式班级 -->
    <div v-if="changeIndex == 2">
      <div class="center-title">
        <span>开放式班级</span>
        <!-- 班级下拉框选择 -->
        <div class="drop-down" v-if="classSelect && openClassList.length > 0" @mouseover="classListShow = true" @mouseleave="classListShow = false">
          <div class="down-title">{{ classSelect.name }}</div>
          <ul class="down-list" v-show="classListShow">
            <li class="down-info" v-for="item in openClassList" :key="item.id" @click="clickClass(item)">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <!-- 视频课程&文本课程&班级考试 选择按钮 -->
      <div class="btns" v-if="openClassList.length > 0">
        <button class="button" :class="tabIndex == 1 ? 'blue' : 'grey'" @click="tableClick(1)">
          视频课程
        </button>
        <button class="button" :class="tabIndex == 3 ? 'blue' : 'grey'" @click="tableClick(3)">
          文本课程
        </button>
        <button class="button" :class="tabIndex == 2 ? 'blue' : 'grey'" @click="tableClick(2)">
          班级考试
        </button>
      </div>
      <!-- 视频课程 -->
      <div class="class_course" v-if="tabIndex == 1 && openClassList.length > 0">
        <div class="course_main">
          <div class="cont_warp">
            <ul>
              <li>
                <p class="label">课程进度</p>
                <div class="progress">
                  <div class="progress-bg">
                    <div class="progress-line" :style="{ width: classData.course_rate + '%' }"></div>
                  </div>
                  <div class="num">{{ classData.course_rate }}%</div>
                </div>
              </li>
              <li>
                <p class="label">学习有效期</p>
                <p class="text">
                  {{ classData.start_time }} 至 {{ classData.end_time }}
                </p>
              </li>
            </ul>
            <ul>
              <li>
                <p class="label">考试情况</p>
                <div class="icon_list">
                  <p class="">
                    <img src="@/assets/true.png" alt="" />
                    <span>{{ classData.exam_success }}项已通过</span>
                  </p>
                  <p class="">
                    <img src="@/assets/false.png" alt="" />
                    <span>{{ classData.exam_fail }}项已通过</span>
                  </p>
                </div>
              </li>
              <div class="flex">
                <li>
                  <p class="label">任务完成进度</p>
                  <p class="text">
                    {{ classData.finish_task }}/{{ classData.task_total }} 任务
                  </p>
                </li>
                <!-- v-if="classData.cert_url && siteInfo.is_open_class_cert==1" -->
                <li class="down_cert" v-if="classData.cert_url">
                  <p class="label">证书下载</p>
                  <p class="text">
                    <a :href="classData.cert_url">证书下载</a>
                  </p>
                </li>
              </div>
            </ul>
          </div>
        </div>
        <ul class="class-list">
          <li class="class-list-info" v-for="item in classCourse" :key="item.id">
            <router-link :to="'/recordedInfo/' + item.id">
              <img class="info-img" :src="item.image" alt="" />
              <div class="info-content">
                <div class="info-title vertical-ellipsis">{{ item.name }}</div>
                <div class="progress">
                  <div class="num">{{ item.rate }}</div>
                  <div class="progress-bg">
                    <div class="progress-line" :style="{ width: item.rate }"></div>
                  </div>
                </div>
              </div>
            </router-link>
          </li>
          <li class="no-data" v-if="classCourse.length == 0">
            班级内还没有课程
          </li>
        </ul>
      </div>
      <!-- 文本课程 -->
      <div class="text_course_list" v-if="tabIndex == 3 && textCourseList">
        <ul>
          <li v-for="item in textCourseList" :key="item.id" @click="goTextDetail(item.id)">
            <p class="img">
              <img :src="item.image" alt="">
            </p>
            <p class="text">{{ item.title }}</p>
          </li>
          <li class="no-data" v-if="textCourseList.length == 0">班级内还文本课程</li>
        </ul>
      </div>
      <!-- 班级考试 -->
      <ul class="test-list" v-if="tabIndex == 2 && openClassList">
        <li class="test-info" v-for="item in classExam" :key="item.id">
          <div class="exam-card-head">
            <span class="exam-badge">考试</span>
            <h3 class="test-title vertical-ellipsis">{{ item.exam_name }}</h3>
          </div>
          <div class="test-date">
            <div class="test-date-text">
              <span>{{ item.start_time }}</span>
              <span class="date-to">至 {{ item.end_time }}</span>
            </div>
          </div>
          <div class="exam-actions">
            <router-link :to="'/text/' + item.id + '/' + '2'" class="exam-btn exam-btn-primary">去考试</router-link>
            <div class="exam-actions-sub">
              <button
                class="exam-btn exam-btn-secondary"
                :disabled="isBtnLocked('score', item.id)"
                @click="viewScoreBtn(item.id, item.exam_name)"
              >查看分数</button>
              <button
                class="exam-btn exam-btn-secondary"
                :disabled="isBtnLocked('record', item.id)"
                @click="viewExamRecordBtn(item.id, item.exam_name)"
              >查看试卷</button>
            </div>
          </div>
          <div class="residue">
            <span class="residue-label">剩余次数</span>
            <span class="num">{{ item.times - item.count }}</span><span class="residue-unit">次</span>
          </div>
        </li>
        <li class="no-data" v-if="classExam.length == 0">班级内还没有考试</li>
      </ul>
      <div class="view-score" v-if="viewScore && openClassList">
        <div class="score-content">
          <div class="close" @click="viewScore = false"></div>
          <div class="score-title">{{ viewScoreTitle }}</div>
          <ul class="my-table">
            <li class="table-th">
              <span class="table-td" style="width: 150px">id</span>
              <span class="table-td" style="width: 200px">考试时间</span>
              <span class="table-td" style="width: 180px">分数</span>
            </li>
            <li class="table-tr" v-for="(item) in queryScore.list" :key="item.created_at">
              <span class="table-td" style="width: 150px">{{ item.id }}</span>
              <span class="table-td" style="width: 200px">{{item.created_at}}</span>
              <span class="table-td" style="width: 180px">{{queryScore.is_show_score==1 ? item.score : '--'}}</span>
              <p class="btn" v-if="queryScore.is_show_score==1" @click="examDetail(item)">查看</p>
            </li>
            <li class="table-tr nodata" v-if="queryScore.list.length == 0">
              <span class="table-td">暂无分数</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 查看试卷记录 -->
      <div class="view-score" v-if="viewExamRecord && openClassList">
        <div class="score-content exam-record-content">
          <div class="close" @click="viewExamRecord = false"></div>
          <div class="score-title">{{ examRecordTitle }}</div>
          <ul class="my-table">
            <li class="table-th">
              <span class="table-td" style="width: 80px">ID</span>
              <span class="table-td" style="width: 200px">考试时间</span>
              <span class="table-td" style="width: 100px">分数</span>
              <span class="table-td" style="width: 80px">操作</span>
            </li>
            <li class="table-tr" v-for="item in examRecordList" :key="item.id">
              <span class="table-td" style="width: 80px">{{ item.id }}</span>
              <span class="table-td" style="width: 200px">{{ item.created_at }}</span>
              <span class="table-td" style="width: 100px">{{ examRecordData.is_show_score == 1 ? item.score : '--' }}</span>
              <span class="table-td" style="width: 80px">
                <p class="btn" @click="examRecordDetail(item)">查看</p>
              </span>
            </li>
            <li class="table-tr nodata" v-if="examRecordList.length == 0">
              <span class="table-td">暂无考试记录</span>
            </li>
          </ul>
          <div class="exam-record-pagination" v-if="examRecordData.list && examRecordData.list.last_page > 1">
            <button class="button grey" :disabled="examRecordPage <= 1" @click="examRecordPageChange(examRecordPage - 1)">上一页</button>
            <span class="page-info">{{ examRecordPage }} / {{ examRecordData.list.last_page }}</span>
            <button class="button grey" :disabled="examRecordPage >= examRecordData.list.last_page" @click="examRecordPageChange(examRecordPage + 1)">下一页</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ClassInfo",
  data() {
    return {
      tabIndex: 1, //标签类型
      classList: "", //班级列表
      openClassList: '',//开放式班级列表
      classListShow: false, //班级列表显示隐藏
      classSelect: "", //选中班级
      classCourse: "", //课程列表
      classExam: "", //考试列表
      viewScore: false, //查看分数弹窗
      viewScoreTitle: "", //弹窗标题
      // 分数数据结构：模板会读取 `queryScore.list.length` 等字段，
      // 所以需要保证至少有一个空数组，避免首次渲染/异步赋值时读取 undefined。
      queryScore: { list: [], is_show_score: 0 }, //分数数据
      viewExamRecord: false, //查看试卷弹窗
      examRecordTitle: '', //试卷弹窗标题
      examRecordExamId: null, //当前查询的考试ID
      examRecordPage: 1,
      examRecordData: { is_show_score: 0, list: { data: [], current_page: 1, total: 0, last_page: 1, per_page: 20 } },
      classData: "",

      changeIndex: 1,
      siteInfo: '',
      textCourseList: [],//文本课程
      clickGuard: {}, // 按钮防抖锁
    };
  },
  computed: {
    examRecordList() {
      const list = this.examRecordData.list;
      return list && Array.isArray(list.data) ? list.data : [];
    },
  },
  mounted() {
    if (localStorage.getItem('classTypeIndex')) {
      this.changeIndex = localStorage.getItem('classTypeIndex')
    }
    this.siteInfo = JSON.parse(localStorage.getItem('siteInfo')) ? JSON.parse(localStorage.getItem('siteInfo')) : '';

    if (this.changeIndex == '1') {
      this.getClassList(); //获取班级列表
    } else {
      this.getOpenClass(); //获取班级列表
    }
    // this.getOpenClass();//
  },
  methods: {
    isBtnLocked(type, id) {
      return !!this.clickGuard[`${type}_${id}`];
    },
    // 防抖：请求进行中忽略重复点击，结束后冷却 500ms
    guardClick(key, fn, cooldown = 500) {
      if (this.clickGuard[key]) return;
      this.$set(this.clickGuard, key, true);
      const release = () => {
        setTimeout(() => {
          this.$set(this.clickGuard, key, false);
        }, cooldown);
      };
      let ret;
      try {
        ret = fn();
      } catch (err) {
        release();
        throw err;
      }
      if (ret && typeof ret.finally === 'function') {
        ret.finally(release);
      } else {
        release();
      }
    },
    changeTab(num) {
      this.changeIndex = num;
      this.tabIndex = "1";
      this.classList = []
      this.openClassList = []
      localStorage.setItem('classTypeIndex', num)
      this.classSelect = ''
      if (this.changeIndex == '1') {
        this.getClassList(); //获取班级列表
      } else {
        this.getOpenClass(); //获取班级列表
      }
    },
    //获取班级列表
    getClassList() {
      this.$axios
        .post(`/v1/personal/classList`, {}, { useLog: true })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.list.length > 0) {
              this.classList = res.data.list;
              this.clickClass(res.data.list[0]);
            }
          } else {
            this.classList = []
            this.openClassList = []
            // this.changeIndex=2
          }


          // else{
          //   this.changeIndex=2
          //   this.getOpenClass()
          // }
        });
    },
    getOpenClass() {
      this.$axios
        .post(`/v1/openClass/classList`, {}, { useLog: true })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.list.length > 0) {
              this.openClassList = res.data.list;
              this.clickClass(res.data.list[0]);
            }
          } else {
            this.classList = []
            this.openClassList = []
          }


          // else{
          //   this.changeIndex=1
          //    this.getClassList();
          // }
        });
    },
    // 获取文本课程
    getTextCourseList() {
      this.$axios.post(`/v1/openClass/classTextCourse`, { class_id: this.classSelect.id }, { useLog: true }).then(res => {
        if (res.code == 0) {
          this.textCourseList = res.data
        } else {
          this.textCourseList = []
        }
      })
    },
    // 文本课程-跳转到详情
    goTextDetail(id) {
      this.$router.push('/textCourse/detail?id=' + id)
    },
    getClassData(id) {
      let url = this.changeIndex == '1' ? '/v1/personal/myClass' : '/v1/openClass/myClass'

      this.$axios
        .post(
          url,
          {
            class_id: id,
          },
          { useLog: true }
        )
        .then((res) => {
          if (res.code == 0) {
            if (res.data.cert_url) {
              res.data.cert_url = res.data.cert_url.replace("http:", "https:");
            }
            this.classData = res.data;
            this.classCourse = res.data.courseList;
            this.classExam = res.data.examList;
          }
        });
    },
    //选择班级
    clickClass(item) {
      this.classSelect = item;
      this.classListShow = false;
      if (this.tabIndex == 1) {
        //课程
        // this.getClassCourse(item.id);
        this.getClassData(item.id);
      } else {
        // 考试：需要在切换班级时同步考试列表，否则 tab 切到公开考试会是空的
        if (this.changeIndex == 2) {
          // 开放式班级在下面统一拉课/考，这里不重复请求
        } else {
          this.getClassExam(item.id);
        }
      }
      if (this.changeIndex == 2) {
        this.getTextCourseList()
        this.getClassData(this.classSelect.id);
      }
    },
    //获取班级课程
    getClassCourse(id) {
      let url = this.changeIndex == '1' ? '/v1/personal/classCourse' : '/v1/openClass/classCourse'

      this.$axios
        .post(
          url,
          {
            class_id: id,
          },
          { useLog: true }
        )
        .then((res) => {
          this.classCourse = res.data;
        });
    },
    //获取班级考试
    getClassExam(id) {
      let url = this.changeIndex == '1' ? '/v1/personal/classExam' : '/v1/openClass/classExam'

      this.$axios
        .post(url,
          {
            class_id: id,
          },
          { useLog: true }
        )
        .then((res) => {
          this.classExam = res.data;
        });
    },
    //课程/标签选择
    tableClick(index) {
      if (this.tabIndex != index) {
        this.tabIndex = index;

        if (index == 3) {
          // tabIndex==3 在不同入口含义不同：
          // - 个人班：公开考试 => 刷考试列表
          // - 开放式班：文本课程 => 刷文本课程列表
          if (this.changeIndex == 2) {
            this.getTextCourseList();
          } else {
            if (this.classSelect && this.classSelect.id) {
              this.getClassExam(this.classSelect.id);
            }
          }
        } else {
          this.getClassData(this.classSelect.id);
        }
      }
    },
    //查看分数
    viewScoreBtn(id, name) {
      this.guardClick(`score_${id}`, () => {
        let url = this.changeIndex == '1' ? '/v1/personal/queryScore' : '/v1/openClass/queryScore'

        return this.$axios
          .post(
            url,
            {
              exam_id: id,
            },
            { useLog: true }
          )
          .then((res) => {
            this.viewScoreTitle = name;
            // 先设置 queryScore，避免 viewScore 打开后模板读取到旧的/空的 queryScore。
            // 兼容两种接口结构：
            // 1) res.data 直接是数组：[{...}, ...]
            // 2) res.data 是对象且包含 list：{ list: [{...}], is_show_score: 1, ... }
            const payload = res ? res.data : undefined;
            if (Array.isArray(payload)) {
              this.queryScore = {
                list: payload,
                // 接口没给时默认展示分数（否则页面会一直显示 '--'）
                is_show_score: 1,
              };
            } else {
              const data = payload && typeof payload === 'object' ? payload : {};
              this.queryScore = {
                list: Array.isArray(data.list) ? data.list : [],
                is_show_score: data.is_show_score != null ? data.is_show_score : 1,
                ...data,
              };
            }
            this.viewScore = true;
          });
      });
    },
    // 查看考试详情
    examDetail(row) {
      this.guardClick(`detail_${row.id}`, () => {
        this.$router.push('/userCenter/exam_detail?id=' + row.id + '&type=' + this.changeIndex);
      }, 800);
    },
    // 查看试卷记录列表
    viewExamRecordBtn(examId, name) {
      this.guardClick(`record_${examId}`, () => {
        this.examRecordExamId = examId;
        this.examRecordTitle = name;
        this.examRecordPage = 1;
        return this.fetchExamRecordList(1);
      });
    },
    fetchExamRecordList(page) {
      const url = this.changeIndex == '1'
        ? '/v1/personal/examRecordList'
        : '/v1/openClass/examRecordList';

      return this.$axios
        .post(
          url,
          {
            exam_id: this.examRecordExamId,
            per_page: 20,
            page: page,
          },
          { useLog: true }
        )
        .then((res) => {
          if (res.code == 0) {
            const data = res.data || {};
            const list = data.list && typeof data.list === 'object' ? data.list : {};
            this.examRecordData = {
              is_show_score: data.is_show_score != null ? data.is_show_score : 1,
              list: {
                data: Array.isArray(list.data) ? list.data : [],
                current_page: list.current_page || page,
                total: list.total || 0,
                last_page: list.last_page || 1,
                per_page: list.per_page || 20,
              },
            };
            this.examRecordPage = page;
            this.viewExamRecord = true;
          }
        });
    },
    examRecordPageChange(page) {
      const lastPage = this.examRecordData.list.last_page || 1;
      if (page < 1 || page > lastPage) return;
      this.guardClick(`record_page_${this.examRecordExamId}_${page}`, () => {
        return this.fetchExamRecordList(page);
      });
    },
    // 查看某次考试答题详情
    examRecordDetail(row) {
      this.guardClick(`record_detail_${row.id}`, () => {
        this.viewExamRecord = false;
        this.$router.push('/userCenter/exam_detail?id=' + row.id + '&type=' + this.changeIndex);
      }, 800);
    },
  },
};
</script>

<style scoped lang="scss">
.center-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btns {
  margin-bottom: 34px;

  .button {
    display: inline-block;
    text-align: center;
    margin-right: 14px;

    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
  }
}

// 班级课程
.class_course {
  width: 788px;
  background: #ffffff;

  .course_main {
    width: 750px;
    height: 190px;
    background: #ffffff;
    box-shadow: 0px 0px 7px 1px rgba(0, 12, 40, 0.14);
    border-radius: 5px 5px 5px 5px;
    margin-bottom: 50px;

    .cont_warp {
      display: flex;
      padding: 26px 30px;

      // justify-content: space-between;
      ul {
        flex: 1;

        li:first-child {
          margin-bottom: 36px;
        }

        li {
          p.label {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            padding-bottom: 10px;
          }

          .icon_list {
            display: flex;
            align-items: center;

            // justify-content: space-between;
            p {
              display: flex;
              align-items: center;
              flex: 1;

              span {
                padding-left: 5px;
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #333333;
              }
            }
          }

          p.text {
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
        }

        .down_cert {
          margin-bottom: 36px;
          flex: 1;
          text-align: center;

          a {
            background: orange;
            color: #fff;
            padding: 6px 15px;
            border-radius: 5px;
            font-size: 14px;
            // font-;
          }
        }

        .progress {
          display: flex;
          align-items: center;

          .num {
            font-size: 12px;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: bold;
            color: #999999;
            margin-left: 10px;
          }

          .progress-bg,
          .progress-line {
            width: 154px;
            height: 3px;
            background: #e5e5e5;
            box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.3);
            border-radius: 3px;
          }

          .progress-line {
            background: #254ed4;
          }
        }
      }
    }
  }
}

.class-list,
.test-list {
  width: 750px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;

  &::after {
    content: "";
    display: block;
    width: 28%;
  }
}

.class-list-info {
  box-sizing: border-box;
  width: 230px;
  background: #fff;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  margin-bottom: 30px;

  .info-img {
    width: 100%;
    height: 142px;
  }

  .info-content {
    padding: 14px 20px 14px;
  }

  .info-title {
    height: 40px;
    font-size: 14px;
    color: #333;
    line-height: 20px;
  }

  .progress {
    padding-top: 14px;
    border-top: 1px solid rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .num {
      font-size: 14px;
      color: #000;
      text-shadow: 0px 0px 50px rgba(0, 0, 0, 0.3);
    }

    .progress-bg,
    .progress-line {
      width: 154px;
      height: 3px;
      background: #e5e5e5;
      box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.3);
      border-radius: 3px;
    }

    .progress-line {
      background: #254ed4;
    }
  }
}

.test-info {
  box-sizing: border-box;
  width: 230px;
  background: #fff;
  padding: 0;
  box-shadow: 0 2px 16px rgba(0, 12, 40, 0.08);
  border-radius: 10px;
  margin-bottom: 30px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s, transform 0.2s;

  &:hover {
    box-shadow: 0 6px 24px rgba(0, 12, 40, 0.12);
    transform: translateY(-2px);
  }

  .exam-card-head {
    padding: 16px 16px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .exam-badge {
    align-self: flex-start;
    font-size: 10px;
    font-weight: 500;
    color: #254ed4;
    background: #eef2ff;
    padding: 2px 8px;
    border-radius: 4px;
    letter-spacing: 0.5px;
  }

  .test-title {
    width: 100%;
    min-height: 20px;
    max-height: 40px;
    font-size: 14px;
    font-weight: 600;
    color: #1a1a2e;
    line-height: 20px;
    margin: 0;
  }

  .test-date {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin: 12px 16px 0;
    padding: 10px 12px;
    background: #f7f8fa;
    border-radius: 6px;
    height: auto;
    line-height: 1.4;

    &::before {
      content: '';
      flex-shrink: 0;
      width: 14px;
      height: 14px;
      margin-top: 2px;
      background: url(~@/assets/clock-ico.png) no-repeat center;
      background-size: contain;
    }

    .test-date-text {
      flex: 1;
      min-width: 0;
      font-size: 11px;
      color: #888;

      span {
        display: block;
        word-break: break-all;
      }

      .date-to {
        margin-top: 2px;
        color: #aaa;
      }
    }
  }

  .exam-actions {
    padding: 14px 16px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .exam-btn {
      box-sizing: border-box;
      display: block;
      border: none;
      cursor: pointer;
      text-decoration: none;
      text-align: center;
      border-radius: 6px;
      font-size: 12px;
      transition: opacity 0.15s, background 0.15s;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .exam-btn-primary {
      width: 100%;
      height: 32px;
      line-height: 32px;
      background: #254ed4;
      color: #fff;
      font-weight: 500;

      &:hover {
        background: #1e3fb8;
      }
    }

    .exam-actions-sub {
      display: flex;
      gap: 8px;
    }

    .exam-btn-secondary {
      flex: 1;
      height: 28px;
      line-height: 28px;
      background: #fff;
      color: #666;
      border: 1px solid #e8eaf0;
      font-size: 11px;
      min-width: 0;

      &:hover:not(:disabled) {
        border-color: #254ed4;
        color: #254ed4;
        background: #f8f9ff;
      }
    }
  }

  .residue {
    display: flex;
    align-items: baseline;
    gap: 4px;
    margin: 14px 16px 16px;
    padding-top: 12px;
    border-top: 1px solid #f0f2f5;
    font-size: 11px;
    color: #999;
    line-height: 1;

    .residue-label {
      color: #bbb;
    }

    .num {
      font-size: 18px;
      font-weight: 600;
      color: #254ed4;
      line-height: 1;
    }

    .residue-unit {
      color: #999;
      font-size: 11px;
    }
  }
}

.drop-down {
  height: 20px;
  position: relative;

  .down-title,
  .down-info {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #666;
    font-weight: normal;
    padding-right: 18px;
    background: url(~@/assets/arrows.png) no-repeat right center #fff;
    background-size: 12px;
    white-space: nowrap;
    cursor: pointer;
  }

  .down-list {
    padding-top: 8px;
    position: absolute;
    top: 20px;
    right: 0;
    background: #fff;
    box-shadow: 1px 1px 10px #999;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 10px;
  }

  .down-info {
    background: none;
    margin-bottom: 5px;
  }
}

.view-score {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 99;

  .score-content {
    width: 600px;
    max-height: 600px;
    padding: 30px;
    background-color: #fff;
    position: relative;

    .score-title {
      font-size: 24px;
      font-weight: 900;
      color: #333;
      margin-bottom: 20px;
    }

    .close {
      width: 30px;
      height: 30px;
      background: url(~@/assets/close-ico.png) no-repeat;
      background-size: 100%;
      position: absolute;
      right: -50px;
      top: 0;
      cursor: pointer;
    }

    p.btn {
      cursor: pointer;
      color: #254ed4;
    }
  }

  .exam-record-content {
    width: 520px;
  }

  .exam-record-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    gap: 16px;

    .page-info {
      font-size: 14px;
      color: #666;
    }

    .button {
      padding: 0 12px;
      height: 28px;
      line-height: 28px;
      font-size: 12px;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}

.my-table {
  max-height: 500px;
  overflow-y: auto;

  .table-th,
  .table-tr {
    height: 50px;

    &.nodata {
      width: 100%;
      justify-content: center;
    }
  }
}

.no-data {
  color: #999;
}

// 文本课程
.text_course_list {
  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      width: 230px;
      margin-right: 30px;

      box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.3);
      margin-bottom: 25px;
      border-radius: 8px;
      padding-bottom: 20px;

      p.img {
        width: 100%;
        height: 150px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 8px 8px 0 0;
        }
      }

      p.text {
        box-sizing: border-box;
        padding: 0 20px;
        font-size: 14px;
        margin-top: 10px;

      }
    }

    li.no-data {
      box-shadow: none;
    }

    li:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>
